export default __webpack_public_path__ + "static/media/employeeDetailsImage.f4e639d0.svg";